import React from 'react';
import type { TriagePatientInfo } from '../../triage/types';
import { Icon } from '../Icon/Icon';
import type { IconKind } from '../Icon/Icon';

const FIELDS: { label: string; key: keyof TriagePatientInfo; icon: IconKind; mono?: boolean; highlight?: boolean }[] = [
  { label: 'Date of birth', key: 'dob', icon: 'team' },
  { label: 'Phone', key: 'phone', icon: 'phone', mono: true },
  { label: 'Insurance', key: 'insurance', icon: 'doc', highlight: true },
];

export interface TriagePatientInfoStripProps {
  info: TriagePatientInfo;
}

export function TriagePatientInfoStrip({ info }: TriagePatientInfoStripProps) {
  return (
    <div
      className="v6-card v6-fade-up v6-d-1"
      style={{ marginBottom: 14, display: 'grid', gridTemplateColumns: '1fr 1fr 1fr' }}
    >
      {FIELDS.map((f, i) => (
        <div
          key={f.label}
          style={{
            padding: '13px 18px',
            borderRight: i < 2 ? '1px solid var(--cream-2)' : 'none',
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <Icon kind={f.icon} size={11} stroke={2} color="var(--ink-3)" />
            <span className="v6-eyebrow" style={{ fontSize: 9.5 }}>
              {f.label}
            </span>
          </div>
          <span
            className={f.mono ? 'v6-mono' : undefined}
            style={{
              fontSize: 14,
              fontWeight: 600,
              color: f.highlight ? 'color-mix(in srgb, var(--success) 80%, #000)' : 'var(--ink-0)',
              letterSpacing: '-0.005em',
            }}
          >
            {info[f.key]}
          </span>
        </div>
      ))}
    </div>
  );
}
